
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/m/[itemId]",
      function () {
        return require("private-next-pages/m/[itemId]/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/m/[itemId]"])
      });
    }
  